import { createName, dataSource } from "../../utils";
const label = '带任务的日历';
const name = 'yesItemCalendar';

export default {
    icon: 'icon-button',
    label,
    name,
    mask: false,
    rule() {
        return {
            type: name,
            props: {
                dataSource: ""
            }
          };
    },
    props() {
        return [
          createName(),
          dataSource()
        ];
      },
};
